import React, { useEffect, useMemo } from "react";
import "../styles/topbanner.css";
import { useSelector, useDispatch } from "react-redux";
import { getSlidesText } from "../actions/SlidesTextActions";

const TopBanner = () => {
  const dispatch = useDispatch();
  const { slidesText, error } = useSelector((state) => state.slidesText);

  useEffect(() => {
    dispatch(getSlidesText());
  }, [dispatch]);

  // Filter only active slide texts - must be called before any early returns
  const activeSlidesText = useMemo(() => {
    if (!slidesText || slidesText.length === 0) return [];
    return slidesText.filter((slide) => slide.status === "active");
  }, [slidesText]);

  if (
    error ||
    !slidesText ||
    slidesText.length === 0 ||
    activeSlidesText.length === 0
  )
    return null;

  return (
    <div className="top-banner">
      <div className="banner-container">
        <marquee
          className="banner-marquee"
          behavior="scroll"
          direction="left"
          scrollamount="5"
          loop="true"
          width="100%"
        >
          {activeSlidesText.map((slide, index) => (
            <span key={slide.slide_text_id} className="announcement">
              <span
                className="announcement-text"
                dangerouslySetInnerHTML={{ __html: slide.text }}
              />
              {index < activeSlidesText.length - 1 && (
                <span className="marquee-separator"> |</span>
              )}
            </span>
          ))}
        </marquee>
      </div>
    </div>
  );
};

export default TopBanner;
